import update from 'immutability-helper';
import {
  RECEIVED_MARKERS,
  RECEIVED_LOCATIONS,
  MAP_CHECKBOX_UNCHANGED,
  MAP_DESELECT_ALL_CHECKBOX,
  ORDER_REMOVE_LOCATION,
  DROPPING_ANIMATION_START,
  DROPPING_ANIMATION_FINISH,
  FLYING_ANIMATION_START,
  FLYING_ANIMATION_FINISH,
  CLEAN_ORDERS,
  DISABLE_SUBMIT,
  MAP_SELECT_ALL_CHECKBOX,
} from '../constants/index';

const initialState = {
  selectedLocations: [],
  markers: [],
  locationList: [],
  arealist: [],
  flyingAnimation: false,
  droppingAnimation: false,
  animatedLocation: {},
  disableButtonSubmit: [],
};

const mainReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVED_MARKERS: {
      return { ...state, markers: action.response };
    }

    case RECEIVED_LOCATIONS: {
      return { ...state, locationList: action.response };
    }

    case MAP_CHECKBOX_UNCHANGED: {
      const updateAreaList = { ...state.arealist[action.id], checked: !action.isSelected };

      const updatedState = [...state.arealist.slice(0, action.id),
        updateAreaList, ...state.arealist.slice(action.id + 1)];

      return { ...state, arealist: updatedState };
    }

    case MAP_DESELECT_ALL_CHECKBOX: {
      const updateState = state.arealist.map((city) => {
        city.checked = false; // eslint-disable-line no-param-reassign

        return city;
      });

      return { ...state, arealist: updateState };
    }

    case MAP_SELECT_ALL_CHECKBOX: {
      const updateState = state.arealist.map((city) => {
        city.checked = true; // eslint-disable-line no-param-reassign

        return city;
      });

      return { ...state, arealist: updateState };
    }

    case DROPPING_ANIMATION_START: {
      return {
        ...state,
        animatedLocation: action.location,
        droppingAnimation: true,
        flyingAnimation: false,
      };
    }

    case DROPPING_ANIMATION_FINISH: {
      return {
        ...state,
        droppingAnimation: false,
      };
    }

    case FLYING_ANIMATION_START: {
      return {
        ...state,
        flyingAnimation: true,
      };
    }

    case FLYING_ANIMATION_FINISH: {
      const newLocationObject = {
        loc_id: state.animatedLocation.loc_id,
        name: (state.animatedLocation.localized_info)
          ? state.animatedLocation.localized_info.heading
          : state.animatedLocation.address_title,
        link: (state.animatedLocation.localized_info)
          ? state.animatedLocation.url
          : window.location.pathname,
        position_index: state.animatedLocation.position_index,
        gategory_for_ga: (state.animatedLocation.localized_info)
          ? state.animatedLocation.localized_info.category_for_ga
          : state.animatedLocation.category_for_ga,
      };

      return {
        ...state,
        selectedLocations: [...state.selectedLocations, newLocationObject],
        flyingAnimation: false,
        animatedLocation: {},
        disableButtonSubmit: [...state.selectedLocations, newLocationObject],
      };
    }

    case ORDER_REMOVE_LOCATION: {
      let locationIndex;

      state.selectedLocations.forEach((location, i) => {
        if (location.loc_id === action.loc_id) {
          locationIndex = i;
        }
      });

      return {
        ...state,
        selectedLocations: update(state.selectedLocations, { $splice: [[locationIndex, 1]] }),
        disableButtonSubmit: update(state.selectedLocations, { $splice: [[locationIndex, 1]] }),
      };
    }

    case CLEAN_ORDERS: {
      return {
        ...state,
        selectedLocations: [],
      };
    }

    case DISABLE_SUBMIT: {
      return {
        ...state,
        disableButtonSubmit: [],
      };
    }

    default: {
      return state;
    }
  }
};

export default mainReducer;
